import { createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle `
@font-face {
  font-family: 'AudiType';
  src: url('https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2')
    format('woff2-variations');
  font-display: swap;
  font-style: normal;
  font-stretch: 100% 130%;
}
`;
//# sourceMappingURL=index.js.map